import { Component, OnInit, ViewChild } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions, TdFileUploadComponent, TdDialogService, TdLoadingService } from '@covalent/core';
import { ProductService } from '../product.service';
import { Product } from '../product';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location } from '@angular/common';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/filter';
import { Observable } from 'rxjs/Observable';
import { FileUploadService } from '../../../../shared/services/file-upload.service';
import { MdSelect } from '@angular/material';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Supplier } from '../../suppliers/supplier';
import { LocationService } from 'services/location.service';
import { SupplierService } from '../../suppliers/supplier.service';

@Component({
  selector: 'app-purchasing-product',
  templateUrl: './purchasing-product.component.html',
  styleUrls: ['./purchasing-product.component.scss'],
  providers: [FileUploadService]
})
export class PurchasingProductComponent implements OnInit {
  @ViewChild('fileUpload') fileUpload: TdFileUploadComponent;

  product: Product;

  fileSelectMultipleMsg: string = 'No file(s) selected yet.';
  fileUploadMultipleMsg: string = 'No file(s) uploaded yet.';
  newProduct: Product;
  data: Product;
  currentProduct: Product = new Product();

  originalProduct: Product = new Product();

  allFabricTypes$: Observable<string[]>;
  allCountriesOfOrigin$: Observable<{ id: number, name: string }[]>;
  allSuppliers$: Observable<{ id: number, name: string }[]>;
  allSuppliers: { id: number, name: string }[] = [];

  allCollections: string[] = [];
  collections: string[];
  allDesigns: string[] = [];
  designs: string[];

  collectionDesignPrices: any[] = [];

  title: string;
  isEditMode: boolean;

  hidden_supplier_id: number = -1;

  constructor(private _productService: ProductService,
    private _supplierService: SupplierService,
    private _locationService: LocationService,
    private _fileUploadService: FileUploadService,
    private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.route.paramMap
      .switchMap((params: ParamMap) => params.get('id')
        ? this.processEdit(params.get('id'))
        : this.processNew())
      .subscribe((currentProduct: Product) => {
        this.currentProduct = currentProduct;

        // Show hidden when hidden
        if (this.allSuppliers.length > 0 && !this.allSuppliers.some(s => { return s.id == Number.parseInt(this.currentProduct.supplier_id) })) {
          this.allSuppliers.unshift(Object.assign(new Supplier(), { id: Number.parseInt(this.currentProduct.supplier_id), name: 'HIDDEN' }));
        }

        this.originalProduct = Object.assign({}, this.currentProduct);

        this._loadingService.resolve('loading');
      });

    this.allFabricTypes$ = this._productService.getProductTypes();
    this.allCountriesOfOrigin$ = this._locationService.getCountry();
    this.allSuppliers$ = this._supplierService.getSuppliers();

    this.allSuppliers$.subscribe(
      (suppliers) => {
        this.allSuppliers = this.allSuppliers.concat(suppliers);

        // Show hidden when hidden
        if (this.allSuppliers.length > 0 && !this.allSuppliers.some(s => { return s.id == Number.parseInt(this.currentProduct.supplier_id) })) {
          this.allSuppliers.unshift(Object.assign(new Supplier(), { id: Number.parseInt(this.currentProduct.supplier_id), name: 'HIDDEN' }));
        }
      }
    );

    this._productService.getDesignPrices().subscribe(
      response => {
        this.collectionDesignPrices = response;
        response.forEach(
          (item) => {
            this.allDesigns.push(item['name']);
            if (!this.allCollections.includes(item['collection_name'])) {
              this.allCollections.push(item['collection_name']);
            }
          }
        );
        this.filterCollections(null, false);
        this.filterDesigns(null, false);
      }
    );
  }

  filterCollections($event: string, filterDesigns: boolean) {
    this.collections = this.allCollections.slice();

    if ($event != null && $event != '') {
      this.collections = this.collections.filter(function (c) { return c.toLowerCase().indexOf($event.toLowerCase()) >= 0 });

      // Filter only the designs for this collection
      this.allDesigns = [];
      this.collectionDesignPrices.forEach(
        (item) => {
          if (item['collection_name'] == $event) {
            this.allDesigns.push(item['name']);
          }
        }
      );
      if (filterDesigns) {
        this.filterDesigns(this.currentProduct.design_name, false);
      }
    }
  }

  filterDesigns($event: string, filterCollections: boolean) {
    this.designs = this.allDesigns.slice();

    if ($event != null && $event != '') {
      this.designs = this.designs.filter(function (d) { return d.toLowerCase().indexOf($event.toLowerCase()) >= 0 });

      // Filter only the collections for this design
      this.allCollections = [];
      this.collectionDesignPrices.forEach(
        (item) => {
          if (item['name'] == $event && !this.allCollections.includes(item['collection_name'])) {
            this.allCollections.push(item['collection_name']);
          }
        }
      );
      if (filterCollections) {
        this.filterCollections(this.currentProduct.collection_name, false);
      }
    }

    // Also show this design's unit price
    let _d_ = this.collectionDesignPrices.filter((cd)=>{return cd['collection_name'] ==this.currentProduct.collection_name && cd['name']==this.currentProduct.design_name })
    
    if (_d_.length == 1) {
      this.currentProduct.unit_price_eur = _d_[0].unit_price_eur;
    }
  }

  collectionExists(c: string) {
    //return c != null && this.allCollections.find((coll) => { return coll == c }) != null;
    // Use the big list instead
    return c != null && this.collectionDesignPrices.find((coll) => { return coll['collection_name'] == c }) != null;
  }

  designExists(d: string) {
    //return d != null && this.allDesigns.find((des) => { return des == d }) != null;
    // Use the big list instead
    return d != null && this.collectionDesignPrices.find((des) => { return des['name'] == d }) != null;
  }

  designInCollection(collection: string, design: string) {
    return collection != null && design != null && this.collectionDesignPrices.find((entry) => { return entry['collection_name'] == collection && entry['name'] == design }) != null;
  }

  processEdit(id: string): Observable<Product> {
    this.route.queryParams.subscribe(
      (params) => {
        if (params['copy']) {
          this.title = 'Copy';
          this.isEditMode = false;
        } else {
          this.title = 'Edit';
          this.isEditMode = true;
        }
      }
    );

    return this._productService.getOneProduct(id);
  }

  processNew(): Observable<Product> {
    this.title = 'New';
    this.isEditMode = false;
    return Observable.of(new Product());
  }

  changed(): boolean {
    for (let prop in this.currentProduct) {
      if (this.currentProduct[prop] != this.originalProduct[prop]) {
        return true;
      }
    }

    return false;
  }

  createProduct() {
    this._loadingService.register('loading');

    this._productService.createProduct(this.currentProduct).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.currentProduct.id = response['id']

          this.originalProduct = Object.assign({}, this.currentProduct);

          this.isEditMode = true;
          this._dialogService.openAlert({
            message: 'Product ' + this.currentProduct.name + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/purchasing', 'products']);
          });

        } else {
          let message: string;
          if (response['error'].startsWith('Duplicate')) {
            message = 'Duplicate product: An entry for ' + this.currentProduct.collection_name + '/' + this.currentProduct.design_name + '/' + this.currentProduct.name + ' already exists';
          } else {
            message = 'Could not create product ' + this.currentProduct.name + ':' + response['error'];
          }

          this._dialogService.openAlert({
            message: message,
            title: 'Failed!',
          });
        }
        this._loadingService.resolve('loading');

      },
      error => {
        this._dialogService.openAlert({
          message: 'Error creating Product ' + this.currentProduct.name + ': ' + error,
          title: 'Error!',
        });
        this._loadingService.resolve('loading');

      },
      () => { }
    );
  }

  saveProduct() {
    this._loadingService.register('loading');

    this._productService.updateProduct(this.currentProduct.id, this.currentProduct).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {

          this.originalProduct = Object.assign({}, this.currentProduct);

          this._dialogService.openAlert({
            message: 'Product ' + this.currentProduct.name + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/purchasing', 'products']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not update Product ' + this.currentProduct.name + '. Try again later',
            title: 'Failed!',
          });
        }
        this._loadingService.resolve('loading');

      },
      error => {
        this._dialogService.openAlert({
          message: 'Error updating Product ' + this.currentProduct.name + ': ' + error,
          title: 'Error!',
        });
        this._loadingService.resolve('loading');

      },
      () => { }
    );
  }

  removePicture(row: string) {
    this.currentProduct.attachments = this.currentProduct.attachments.filter(
      function (a) {
        return a != row;
      }
    );
  }

  /*selectMultipleEvent(files: FileList | File): void {
    if (files instanceof FileList) {
      let names: string[] = [];
      for (let i: number = 0; i < files.length; i++) {
        names.push(files[i].name);
      }
      this.fileSelectMultipleMsg = names.join(',');
    } else {
      this.fileSelectMultipleMsg = files.name;
    }
  }*/
  selectEvent(file: File): void {
    console.log('Selected: ' + file);
  }

  /*uploadMultipleEvent(files: FileList | File): void {
    if (files instanceof FileList) {
      let names: string[] = [];
      for (let i: number = 0; i < files.length; i++) {
        names.push(files[i].name);
      }
      this.fileUploadMultipleMsg = names.join(',');
    } else {
      this.fileUploadMultipleMsg = files.name;
    }
  }*/
  uploadEvent(file: File): void {
    this._fileUploadService.upload(file).subscribe(
      response => {
        this.currentProduct.attachments.push(response.file.url)
      },
      error => {
        console.log(error)
      },
      () => {
        this.fileUpload.cancel();
      }
    );
  }

  /*
  cancelMultipleEvent(): void {
    this.fileSelectMultipleMsg = 'No file(s) selected yet.';
    this.fileUploadMultipleMsg = 'No file(s) uploaded yet.';
  }
  */
  cancelEvent(): void {
    this.fileSelectMultipleMsg = 'No file(s) selected yet.';
    this.fileUploadMultipleMsg = 'No file(s) uploaded yet.';
  }

  goBack(): void {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/products/product/purchasing-product.component.ts